<script>
  import {
    VListItemTitle
  } from 'vuetify/lib'
  export default {
    name: 'wh-list-item-title',
    extends: VListItemTitle
  };
</script>